import { ChangeDetectionStrategy, Component, EventEmitter, Input, type OnInit, Output, ViewChild } from '@angular/core';
import type { PopoverDirective } from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { type BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-date-time-picker',
    templateUrl: './web-date-time-picker.component.html',
    styleUrls: ['./web-date-time-picker.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PopoverModule,
        BsDatepickerModule,
        TimepickerModule,
        ReactiveFormsModule,
        FormsModule,
        DatePipe,
        TranslateModule,
    ],
})
export class WebDateTimePickerComponent implements OnInit {
    public readonly minDate = new Date();

    public time = new Date();
    public date = new Date();
    public dateTime = new Date();
    public datePickerConfig: Partial<BsDatepickerConfig> = {
        dateInputFormat: 'YYYY-MM-DD',
        showWeekNumbers: false,
        selectWeek: false,
        containerClass: 'theme-blue',
    };

    @Input() defaultDate: Date;

    @Output() dateChange = new EventEmitter<Date>();

    @ViewChild('popoverRef') private _popoverRef: PopoverDirective;

    ngOnInit() {
        this.date = this.time = this.dateTime = this.defaultDate ? new Date(this.defaultDate) : this.minDate;
    }

    public dateSelectionDone(ev: any): void {
        this.date = ev;
        this.setDateTime();
    }

    public timeSelectionDone(ev: any): void {
        this.time = ev;
        this.setDateTime();
    }

    public onClose(): void {
        this._popoverRef.hide();
    }

    private setDateTime(): void {
        this.dateTime = new Date(
            this.date.setHours(this.time.getHours(), this.time.getMinutes(), this.time.getSeconds())
        );
        this.dateChange.emit(this.dateTime);
    }
}
